export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_12.7be783a8.JPG";